import React, { useCallback, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { debounce } from 'utils/functions';
import {
  readMessage
} from 'socket/socket';
import { ContainerClientChat } from './ContainerChat/ContainerChat';
import { hideModalChatId } from 'redux_toolkit/reducers/modals/modalsSlice';


export const ClientChat = ({
  canEdit = true,
  chatId,
  hideModal
}) => {
  const dispatch = useDispatch();

  const { chats, watchingChats } = useSelector(({ chat })=> chat);
  const debaunceCallback = debounce(hideModal, 100);

  const readAllMessages = useCallback((chatId)=> {
    return readMessage(chatId);
  }, []);

  const currentChatData = canEdit ? chats.get(chatId) : watchingChats.get(chatId);

  useEffect(()=>{
    if(!currentChatData && canEdit) dispatch(hideModalChatId({chatId}));
    if(currentChatData?.chatOpen === true && !currentChatData?.chatEnd) readAllMessages(chatId);
  }, [
    currentChatData,
    chatId,
    readAllMessages,
    dispatch
  ]);

  if(!chats.get(currentChatData?._id) && canEdit) {
    debaunceCallback()
  }

  return (
    <div>
      {currentChatData && <ContainerClientChat chatData={currentChatData} canEdit={canEdit} chats={chats} />}
    </div>
  )
}
